import { useState } from 'react';
import { Form, Typography, Input, Row } from 'antd';
import GenericModal from '../../buttons/genericModal';
import { backendDeleteWithoutRefresh } from '../../../helpers/callBackend';
import LoadingButton from '@mui/lab/LoadingButton';

const { Text } = Typography;

function UnassignEntityFromBankAccount(props) {
	const [submitting, setSubmitting] = useState(false);
	const [visible, setVisible] = useState(false);

	const onFormSubmitModal = () => {
		let data = {
			bank_account_ids: [props.bankAccount.id]
		}
		setSubmitting(true);
		backendDeleteWithoutRefresh("/api/entity/bank-account/relation/", data)
			.then((res) => {
				if (res) {
					setSubmitting(false);
					setVisible(false);
					props.unassignEntityFromBankAccount(props.bankAccount.id);
				} else {
					setSubmitting(false);
				}
			}).catch((err) => {
				setSubmitting(false);
			});
	};

	return (
		<GenericModal
			size='md'
			visible={visible}
			handleCancelModal={() => setVisible(false)}
			showModal={() => setVisible(true)}
			button={<span>Unassign</span>}
			modalTitle={`Unassign ${props.bankAccount.account.account_description} from ${props.bankAccount.entity_name}`}
			modalBody={
				<Form
					layout="vertical"
					name="basic"
					onFinish={onFormSubmitModal}
					autoComplete="off"
				>
					<Row style={{ marginBottom: "20px" }}>
						<Text>
							Remove the assignment of this bank account from this entity.
						</Text>
					</Row>
					<Row style={{ marginTop: "10px", marginBottom: "10px" }}>
						<Text strong>
							Please write "unassign" below to proceed.
						</Text>
					</Row>
					<Form.Item
						name="entity_id"
						rules={[
							{
								validator: (_, value) =>
									value === 'unassign'
										? Promise.resolve()
										: Promise.reject(new Error('Please write "unassign"')),
							},
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item>
						<LoadingButton
							htmlType="submit"
							loading={submitting}
							style={{ margin: "3px", width: "100%" }}
							loadingPosition="start"
							sx={{ fontSize: 14, textTransform: 'none' }}
							disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
						>
							Submit
						</LoadingButton>
					</Form.Item>
				</Form>
			}
		/>
	)
}

export default UnassignEntityFromBankAccount;